import { Suspense } from 'react';
import { AdminReturnsClient } from './admin-returns-client';

export const metadata = { title: 'Returns | Admin' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <AdminReturnsClient />
    </Suspense>
  );
}
